/**
 * @generated SignedSource<<21ce3bc940ff4adc2748bb83ef335638>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PremiumUpdateDialog_premium$data = {
  readonly endAt: any | null;
  readonly id: string;
  readonly startAt: any;
  readonly " $fragmentType": "PremiumUpdateDialog_premium";
};
export type PremiumUpdateDialog_premium$key = {
  readonly " $data"?: PremiumUpdateDialog_premium$data;
  readonly " $fragmentSpreads": FragmentRefs<"PremiumUpdateDialog_premium">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PremiumUpdateDialog_premium",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    }
  ],
  "type": "MATPremiumApplyHistory",
  "abstractKey": null
};

(node as any).hash = "da2a8bac5b02fc45b83c79b5ef9eed80";

export default node;
